import { LineSeries, Point } from '@nivo/line'
import { TimeZone, ViewDataElementFragment, WidgetBucketSize } from 'types/graphql'

import { getDayjsInTimeZone } from 'src/utils/date'

export enum ChartType {
  Bar = 'Bar',
  Line = 'Line',
  Pie = 'Pie',
}

export const extractViewDataElementNumber = (
  value: ViewDataElementFragment | undefined | null
): number | null => {
  if (!value) {
    return null
  }

  switch (value.__typename) {
    case 'ViewDataElementNumber':
      return value.number
    case 'ViewDataElementCurrencyCents':
      return value.cents
    case 'ViewDataElementDuration':
      return value.seconds
    default:
      return null
  }
}

export const getBucketStartLabel = (
  bucketSize: WidgetBucketSize,
  start: string,
  timeZone?: TimeZone
): string => {
  const date = getDayjsInTimeZone(start, timeZone)
  switch (bucketSize) {
    case 'Hour':
      return date.format('M/D hA')
    case 'Day':
      return date.format('MMM D')
    case 'Week':
      return date.format('MMM D')
    case 'Month':
      return date.format("MMM 'YY")
    default:
      return date.format()
  }
}

export const getPointSeriesId = <TData extends LineSeries>(point: Point<TData>) => {
  /*
    Unfortunately, there is a bug in point.seriesId where the var name in the object is point.serieId, so we need to parse it out manually
    https://github.com/plouc/nivo/issues/2787
  */
  return point.id.split('.')[0] ?? ''
}
